import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        currentSearchKeyword: null,
        searchValue: null,
        bookDetailId: null,
        favoriteBook: [],
        maleActive: true,
        femaleActive: false,
        detailItem: null
    },
    getters :{
        bookDetailId:function () {
            this.axios.get("https://novel.kele8.cn/book-info/" + this.bookDetailId).then(response => {
                // window.console.log(response.data);
                ({ data: this.detailItem } = response);
                localStorage.setItem(
                    "detailItem" + this.bookId,
                    JSON.stringify({
                        time: Date.now(),
                        data: this.detailItem
                    })
                );
            });
          }
    },
    mutations: {
        setChangeGender(state, payload){
            state.maleActive = payload.male;
            state.femaleActive = payload.female;
        },
        setSearchKeyword(state, payload) {
            state.currentSearchKeyword = payload.value;
            state.searchValue = payload.value;
        },
        getAutoSearchWords(state, payload) {
            state.searchValue = payload.value;
        },
        getSearchResult(state, payload) {
            state.searchValue = payload.value;
            Vue.axios
                .get("https://novel.kele8.cn/search", {
                    params: {
                        keyword: state.searchValue
                    }
                })
                .then(response => {
                    window.console.log(response.data.books);
                });
        },
        pushInFavoriteBook(state, payload) {
            state.favoriteBook.push(payload);
        },
        setBookDetailId(state, payload) {
            state.bookDetailId = payload.value;
            window.console.log(state.bookDetailId);
        }
    },
    actions: {},
    modules: {}
});
